import { render, staticRenderFns } from "./MyInfoPersonalAgreePop.vue?vue&type=template&id=e177825c&scoped=true"
import script from "./MyInfoPersonalAgreePop.vue?vue&type=script&lang=js"
export * from "./MyInfoPersonalAgreePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e177825c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e177825c')) {
      api.createRecord('e177825c', component.options)
    } else {
      api.reload('e177825c', component.options)
    }
    module.hot.accept("./MyInfoPersonalAgreePop.vue?vue&type=template&id=e177825c&scoped=true", function () {
      api.rerender('e177825c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/MyInfoPersonalAgreePop.vue"
export default component.exports